export default __webpack_public_path__ + "static/media/registration_icon.7696fcd9.svg";